import React from 'react';
import SimpleCards from './SimpleCards';
import { styled } from "../../../stitches.config";
import IconCard from '../Career/IconCard';
import { ReactComponent as CircleIcon } from '../../../assets/img/natemat/tip/dots.svg?react';
import { body, h1, h2, h4, p } from '../../commonStyles/Fonts';

interface HowItWorksProps {
    items: {
        text: string,
        title: string,
        icon: JSX.Element,
    }[];
    heading: string;
}

const HowItWorks = ({ items, heading }: HowItWorksProps) => {
    return (
        <Container>
            <CircleIcon className='svg' />
            <h2 className={h2()}>{heading}</h2>
            <SimpleCards>
                {
                    items.map((item) => <IconCard text={item.text} title={item.title}>{item.icon}</IconCard>)
                }
            </SimpleCards>
        </Container>
    )
}

export default HowItWorks;

const Container = styled('div', {
    backgroundColor: '$grayscale10',
    color: '$grayscale100',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '40px',
    paddingBottom: '40px',
    gap: '0px',
    padding: '16px',
    '.svg': {
        position: 'absolute',
        right: 0,
        transform: 'rotateY(180deg)',
        top: 0,
        zIndex: 0,
    },
    '*': {
        zIndex: 1,
    },
    '@bp4': {
        paddingTop: '128px',
        paddingBottom: '144px',
        gap: '56px',
        '.svg': {
            position: 'absolute',
            left: 0,
            transform: 'rotateY(0deg)',
            top: 0,
        },
    }
})
